import { render, staticRenderFns } from "./OtaList.vue?vue&type=template&id=b81a56c4&scoped=true"
import script from "./OtaList.vue?vue&type=script&lang=js"
export * from "./OtaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81a56c4",
  null
  
)

export default component.exports